exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: rgb(143, 215, 255);; \n}\n \n/* Handle */\n::-webkit-scrollbar-thumb {\n\n  background: #dadada;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555; \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/add-edit-vehicle-type/add-edit-vehicle-type.component.css
// module id = ../../../../../src/app/add-edit-vehicle-type/add-edit-vehicle-type.component.css
// module chunks = main